<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ac_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ac_custname">
            <label class="weui-form-preview__label">{{customLabel.ac_custname || "客户名称"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.ac_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="ac_industry">
            <label class="weui-form-preview__label">{{customLabel.ac_industry || "行业类型"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ac_industry }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ac_contact">
            <label class="weui-form-preview__label">{{customLabel.ac_contact || "联系人"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.ac_contact }} {{ form.main.ac_tel }}
              <call-mobile :mobile="form.main.ac_tel"></call-mobile>
            </span>
          </div>
        </custom-layout>
      </div>
      <custom-layout class="form-preview weui-form-preview" :view-config="customViewConfig">
        <div class="weui-form-preview__bd" slot="ac_agentname">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{customLabel.ac_agentname || "代理商名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ac_agentname
            }}</span>
          </div>
        </div>
      </custom-layout>
      <custom-layout class="form-preview weui-form-preview" :view-config="customViewConfig">
        <div class="weui-form-preview__bd" slot="ac_remark">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{customLabel.ac_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ac_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="creatorName">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "录入人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ac_auditman">
            <label class="weui-form-preview__label">{{customLabel.ac_auditman || "审核人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ac_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ac_auditdate">
            <label class="weui-form-preview__label">{{customLabel.ac_auditdate || "审核日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ac_auditdate
            }}</span>
          </div>
        </div>
      </custom-layout>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/agent/cust_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <!-- <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      > -->
      <router-link
        :to="'/agent/change?id=' + form.main.id"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >代理商变更</router-link
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    CallMobile
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/agent/agentcust",
      codeField: "ac_code",
      statusField: "ac_statuscode",
      caller: "AgentCust",
      xtype:'agent-agentcust-formpanel'
    };
  }
}
</script>